
// const jumappProd = "https://ipa-utilities.ktbst.co.th/ktbst/v1/services/authen/jumpapp";
// const saxo = "https://onepeace-service.ktbst.co.th/onepeace-saxo-api/api/v1/";

// const jumappDev = "https://test-api-unicorn.ktbst.co.th:3401/ktbst/v1/services/authen/jumpapp";
// const masterDev = "https://onepeace-service.ktbst.co.th/onepeace-saxo-api/api/v1/master";

// const saxoDev = "https://dev-onepeace-service.ktbst.co.th/onepeace-saxo-api/api/v1/";

const env: any = (env) => {
    console.log('ENV',env)
    if (env === "production" || env === "master")
        return {
            baseApi: "https://onepeace-service.daol.co.th/otp-gateway-api/",
            ekycApi: "https://ekyc.daolsecurities.co.th/verify-ekyc?ekycToken=",
            ndidInvApi: "https://oa.daolinvestment.co.th/ndid-offline/home?",
            ndidSecApi: "https://oa.daolsecurities.co.th/ndid-offline/home?",
            reviewSuitKycInvApi: "https://oa.daolinvestment.co.th/review-suit-kyc/home?",

        }
    if (env === "develop" || env === "development" || env === "test")
        return {
            // baseApi: "http://localhost:8080/otp-gateway-api",
            baseApi: "https://dev-onepeace-service.daol.co.th/otp-gateway-api",
            ekycApi: "https://dev-ekyc.daolsecurities.co.th/verify-ekyc?ekycToken=",
            ndidInvApi: "https://uat-oa.daolinvestment.co.th/ndid-offline/home?",
            ndidSecApi: "https://uat-oa.daolsecurities.co.th/ndid-offline/home?",
            reviewSuitKycInvApi: "https://uat-oa.daolinvestment.co.th/review-suit-kyc/home?",
            // jumapp: jumappDev,
            // master: masterDev,
            // saxo: saxoDev,
        }

}
export default env(process.env.REACT_APP_DEPLOY_MENT)